module.exports = __webpack_public_path__ + "e0ba0112eb14f5d44fd19f041bf2596f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/coldstart-dependencies.png
// module id = 253
// module chunks = 1